import { RosterPerson } from 'app/api/roster';

export function buildLoadingPersonFromId(personId: string): RosterPerson {
    return {
        country: '',
        externalId: '',
        givenName: '(Loading)',
        groups: [],
        id: personId,
        locale: '',
        nodes: [],
        personAddresses: [],
        personAttributes: [],
        personEmails: [],
        personPhones: [],
        pronouns: { objective: '', subjective: '' },
        subscriptions: [],
        surname: '',
        username: `loading-person-${personId}`
    };
}

export function buildNotFoundPersonFromId(personId: string): RosterPerson {
    return {
        country: '',
        externalId: '',
        givenName: `Unknown person (ID ${personId})`,
        groups: [],
        id: personId,
        locale: '',
        nodes: [],
        personAddresses: [],
        personAttributes: [],
        personEmails: [],
        personPhones: [],
        pronouns: { objective: '', subjective: '' },
        subscriptions: [],
        surname: '',
        username: `unknown-person-${personId}`
    };
}
